import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import {
  constructionAsset,
  constructionSafety,
  logisticsAsset,
  medicalPatient,
  medicalWaste,
  retailOffice,
} from '@pages/Enterprise/Solution/components/Banner/BannerImages';

export default {
  desc: 'Công nghệ UWB (Ultra-Wideband) là một công nghệ truyền thông không dây sử dụng băng thông tần số rất rộng để truyền dữ liệu hoặc đo lường chính xác vị trí của vật thể. UWB sử dụng các xung cực ngắn trong một khoảng thời gian ngắn, qua đó tạo ra tín hiệu có độ phân giải cao.',
  keywords: 'UWB, geofence, geofencing, khu vực an ninh, UWB, geofence, geofencing, khu vuc an ninh.',
  ogSite: 'Sự đổi mới của hệ thống Geofence sử dụng công nghệ UWB siêu chính xác',
  title: 'Sự đổi mới của hệ thống Geofence sử dụng công nghệ UWB siêu chính xác',
  ogUrl: 'https://orbro.io/vi/blog/uwbGeofence',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AKsag4MxDPsSDiu2Tyl6nzt6wk9OfJpf_lWTcfXeVRyvIzqQCB1pSV0Spq8jW3WvcY7Nw02jSYqstCQAImKsHtFRK-1bPx1X2mx0YaBIiayQ1ohB3l7WHUYrrwPX0KVYOmKZg-lo7OXiR53dsL16RqpSTSGdQaV46-p40ThUaFoYxY-hUVgD4l18QurSDnaKVaSL_qZ6ApBj7LSbjfbjVaUNEOXWI3bT5GNmDdlLfWBv8id417JIjgIeDW3iI_kkzevdCiKHN2ORcK4RYGPGFVeAOL8wlco80gszm93LArYd2nOvTK38arZmeYvJ0Ex0nqkjaxulQ7gJ5-a5bSBSfAaKAkqxv24246EQdlkBh9N5COrSoTqrAlmVNNf9PxF2fbxMevrZt-G9NMRIaxYkWT42AfcpxuTL1DikOcn2_q8jFMWhrvSwNYC2No2mZOgbqYoDKytKXp2xOcRM7RKZBhIZhDvfS59FVqMUMiO5aD2j2QizWcy5BI53-fnun3DZdVQTijx4yq1Gg_tQvY36Lu803m17BZ6Fia8uhoZVOdcuNpFsiAttmTR2X_wkCdeti3lj3ovDVjGE7kvZr1CdpkFft3MtDSoL2fhdU6YubXi_uuNfS_zCAwv6er3VjTfUTvPgtciMHUbAv5Ci63iew9qiOj3Fkr0ueSGZk_iqSYP-He2PUYp7TplTlsPd3CmzeGIf03yFNX1FK4RUVfIo55fXbW0n7cuga9vSRYuRF5dsHCTLILV1qr_nJGd-U4u-vO2jRh53ZHXTDgA8dZ_c4XUneNWJ0_JDYNOTmzrgJJsCDvH8-J28NyJVw-UBpgUGYZRMnhoPclDHRXAMcy5YvwsLVCLajck2ewTifU3gOr8SHNlFP_wOpK7_L5WgP7GHPYE04bZbHZ-bjCxcDM8E3wQYn32oUrEammRi0mbSb7xPPr9azb_14nmPjd1d-Ppay-29QzX8A1B5GRo4emyzqI0NMMPmDryb4QTIsKI9fYTbZsQ3fUoPH3HnNRZtpmVc-Ht1Gld7epvFpcrD199Ery-c1XIEEvw9PSDjteUY1-RMoyDutgDc06huKQxZv_wx-vfxmu-GnVz6kDHYQtEKULMtqxhF-8f65nC-p8nnbYD59CkksLRWPzzKmq7c51Sq1UDLuOqDPlnpema8t7VSg2iWUNi7pqgxfwnt1BSPeRt8XrPv8dmTmudreTbSR1g-7x4fAzf1PxU2QyGOmbVEq_5L4HNxOmJQzGnEYOxtPcTWL1G-vYS58iH6octXtcqiXoFymXxnt5sHnpCaYK1cpWTWUCjEMjJi8r2YOEPxBfzHv4VUeME1bB91xu2jsZhQC09SylsHJZZcLxW_jG4v2EzHsKI87CaHQCimSgcaP_8Iy3GPUVQdbOnRXT8XSow67w2sItu6ujbKZCr1aT7l54ree-kMoWfM3urhWArs2mQE2_oo0_eSh__SdYlxYh56m64zFkguxTpaecjUFam-ty20MdiuW5LkVjoNPR4A_9HsbmFYn_lQ8Pqc6jtL3FDml1vyeTYAYYv2XMQxoZvyGZBYbTU=w2000-h1736',
  ogType: 'website',
  date: '2023-09-01',
  tag1: '#UWB',
  tag2: '#Geofence',
  tag3: '#Geofencing',
  tag4: '#Khuvucanninh',
  text: [
    {
      head: 'UWB - Công nghệ băng thông siêu rộng siêu chính xác là gì?',
      subHead: '',
      desc: 'Công nghệ UWB (Ultra-Wideband) là một công nghệ truyền thông không dây sử dụng băng thông tần số rất rộng để truyền dữ liệu hoặc đo lường chính xác vị trí của vật thể. UWB sử dụng các xung cực ngắn trong một khoảng thời gian ngắn, qua đó tạo ra tín hiệu có độ phân giải cao. Việc tận dụng các tín hiệu có độ phân giải cao này cho phép theo dõi vị trí và đo khoảng cách một cách chính xác trong cả môi trường trong nhà và ngoài trời. Công nghệ UWB có đặc điểm là cung cấp tốc độ truyền dữ liệu cao và độ chính xác đo lường vị trí tốt ngay cả với mức tiêu thụ điện năng thấp, do đó được ứng dụng trong nhiều lĩnh vực khác nhau.',
      dot: '',
    },
    {
      head: 'Geofence (Geofencing) là gì?',
      subHead: '',
      desc: 'Geofence là công nghệ kết hợp dịch vụ dựa trên vị trí và công nghệ không dây để gửi cảnh báo hoặc thực hiện các hành động cụ thể khi có sự kiện xảy ra trong một khu vực địa lý nhất định. Nói một cách đơn giản, Geofence có nghĩa là thiết lập một hàng rào ảo và thực hiện các biện pháp cụ thể khi có đối tượng đi ra hoặc đi vào phạm vi đó. Geofence có thể được sử dụng kết hợp với các công nghệ theo dõi vị trí như GPS, Wi-Fi, Bluetooth và UWB. Nhờ đó, có thể thiết lập chính xác khu vực Geofence dựa trên thông tin vị trí thời gian thực, và gửi thông báo hoặc thực hiện các hành động cụ thể khi người dùng hoặc thiết bị đi vào bên trong hoặc ra ngoài một khu vực nhất định.',
      dot: '',
    },
    {
      head: 'Sự đổi mới của hệ thống Geofence nhờ ứng dụng công nghệ UWB siêu chính xác',
      subHead: '',
      desc: 'Trong những năm gần đây, đổi mới công nghệ đang làm thay đổi mạnh mẽ cuộc sống của chúng ta. Trong số đó, công nghệ UWB (Ultra-Wideband) siêu chính xác là một chủ đề đang nhận được sự quan tâm lớn trong việc xây dựng các hệ thống Geofence đột phá. Công nghệ này tận dụng băng thông rộng để cho phép theo dõi vị trí và đo khoảng cách một cách chính xác và nhanh chóng, điều mà trước đây rất khó thực hiện. Dựa trên cơ sở đó, chúng ta hãy cùng tìm hiểu xem công nghệ UWB được ứng dụng như thế nào trong lĩnh vực Geofence và mang lại những đổi mới gì.',
      dot: '',
    },
    {
      head: '',
      subHead: '1. Theo dõi vị trí siêu chính xác',
      desc: 'Công nghệ UWB cung cấp khả năng theo dõi vị trí rất tinh vi. Tận dụng điều này, hệ thống Geofence có thể xác định vị trí của vật thể hoặc cá nhân theo thời gian thực. Ví dụ, nếu có khu vực cấm tiếp cận trong một cơ sở, hệ thống có thể xác định vị trí của những người đang tiếp cận theo thời gian thực và tự động gửi cảnh báo. Hơn nữa, trong lĩnh vực quân sự, nó không chỉ mang lại lợi thế trong việc giám sát và kiểm soát chính xác sự di chuyển của đối phương, mà trong lĩnh vực dân sự, nó còn cung cấp lợi thế quản lý hiệu quả hơn vị trí của các công trình hoặc vật tư.',
      dot: '',
    },
    {
      head: '',
      subHead: '2. Trực quan hóa và giám sát',
      desc: 'Hệ thống Geofence sử dụng công nghệ UWB có thể trực quan hóa và giám sát thông tin địa lý với độ chính xác cao. Qua đó, người quản lý có thể theo dõi các chuyển động và hoạt động trong khu vực theo thời gian thực, đồng thời nhận được cảnh báo ngay lập tức về các hành vi bất thường hoặc xâm nhập trái phép để ứng phó.',
      dot: '',
    },
    {
      head: '',
      subHead: '3. Tăng cường an ninh và an toàn',
      desc: 'Công nghệ UWB cung cấp tính bảo mật cao. Việc theo dõi vị trí dựa trên Radar khó bị phát hiện hơn so với tín hiệu GPS, do đó hệ thống Geofence có thể duy trì an toàn, tránh được các cuộc tấn công mạng (hacking) hoặc gây nhiễu từ bên ngoài. Điều này mang lại lợi thế lớn trong các lĩnh vực như bảo vệ thông tin mật, bao gồm cả các cơ sở quân sự.',
      dot: '',
    },
    {
      head: '',
      subHead: '4. Tính đa dụng',
      desc: 'Công nghệ UWB sở hữu tính đa năng, có thể được ứng dụng trong nhiều lĩnh vực khác nhau. Không chỉ theo dõi vị trí, nó còn có thể được sử dụng kết hợp với nhiều chức năng cảm biến (sensing) khác nhau, do đó có tiềm năng ứng dụng trong giám sát môi trường, ứng phó thảm họa, hệ thống tự động hóa, v.v.',
      dot: '',
    },
    {
      head: '',
      subHead: '5. Triển vọng trong tương lai',
      desc: 'Công nghệ UWB đang không ngừng phát triển và được kỳ vọng sẽ cung cấp khả năng cảm biến (sensing) và theo dõi vị trí ngày càng tinh vi hơn. Nhờ đó, hệ thống Geofence được mong đợi sẽ có khả năng quản lý an toàn mạnh mẽ và hiệu quả hơn. Ngoài ra, công nghệ UWB cung cấp dữ liệu hiệu quả và chính xác hơn so với các phương pháp truyền thống, do đó được dự đoán sẽ mang lại độ tin cậy cao trong việc ra quyết định.',
      dot: '',
    },
    {
      head: 'Kết luận',
      subHead: '',
      desc: 'Hệ thống Geofence sử dụng công nghệ UWB siêu chính xác cho phép phòng vệ và quản lý hiệu quả hơn thông qua khả năng theo dõi vị trí và giám sát tinh vi. Sự đổi mới của công nghệ này mang lại những tác động tích cực đến nhiều lĩnh vực trong dân sự, quân sự và an ninh, và trong tương lai, chúng ta có thể kỳ vọng vào sự xuất hiện của các hệ thống Geofence mạnh mẽ hơn nữa nhờ công nghệ UWB ngày càng tiên tiến.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: medicalPatient.thumb,
        data: 'medicalPatient',
        link: '/vi/enterprise/medical/patient',
      },
      {
        img: medicalWaste.thumb,
        data: 'medicalWaste',
        link: '/vi/enterprise/medical/waste',
      },
      {
        img: retailOffice.thumb,
        data: 'retailOffice',
        link: '/vi/enterprise/retail/office',
      },
    ],
  },
};
